import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div style={{ textAlign: 'center', padding: '3rem' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Link to="/" style={{ color: '#646cff', textDecoration: 'none' }}>
        Go back to Dashboard
      </Link>
    </div>
  );
}

export default NotFound;
